<template>
  <div
    v-if="formattedContents.length"
    class="table"
  >
    <div class="table-header">
      <div class="tr-box row">
        <div
          v-for="(header) in formattedHeaders"
          :key="header.label"
          class="th-box columns"
        >
          {{ header.text }}
        </div>
        <div class="th-box columns small-1" />
      </div>
    </div>
    <div class="table-content">
      <div
        v-for="(row, index) in formattedContents"
        :key="index"
        class="tr-box row"
      >
        <div
          v-for="(column) in row"
          :key="column.text"
          class="td-box columns"
        >
          <span>{{ column.text }}</span>
        </div>
        <div class="td-box columns small-1">
          <span
            v-if="removable"
            class="fa fa-times fa-lg cursor-pointer"
            @click="removeRow(index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'SimpleTable',
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    contents: {
      type: Array,
      default: () => [],
    },
    removable: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      scopedContents: lodash.cloneDeep(this.contents),
    }
  },
  computed: {
    formattedHeaders () {
      return this.headers.map(header => header.constructor === Object ? header : {text: header})
    },
    formattedContents () {
      return this.scopedContents.map((row) => {
        if (Array.isArray(row)) {
          return row.map((column, index) => {
            const columnHeader = this.formattedHeaders[index]
            const flex = columnHeader.flex
            return flex ? {flex, text: column} : {text: column}
          })
        } else if (row.constructor === Object) {
          return this.formattedHeaders.map(header => {
            const label = header.label
            const flex = header.flex
            return {
              text: row[label],
              flex,
            }
          })
        }
      })
    },
  },
  methods: {
    addContent (content) {
      this.scopedContents.push(content)
    },
    removeRow (id) {
      this.$emit('removeRow', this.scopedContents[id])
      this.scopedContents.splice(id, 1)
    },
    getContents () {
      return this.scopedContents
    },
    emptyContents () {
      this.scopedContents = []
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/_settings.scss';

.table {
  .table-header {
    color: $tender-font-color;
    border: 1px solid $light-gray;
    font-weight: bold;
    .th-box {
      padding: 8px;
    }
  }
  .table-content {
    border: 1px solid $light-gray;
    border-top: none;
    .tr-box {
      &:nth-child(even) {
        background-color: $white
      }
      &:nth-child(odd) {
        background-color: $table-tr-odd
      }
    }
    .td-box {
      padding: 8px;
      word-wrap: break-word;
      word-break: break-all;
    }
    .cursor-pointer {
      cursor: pointer;
    }
  }
}
</style>
